import { FournisseurCoquille } from "@app/components/compta/coquille/ContexteCoquille";
import { FournisseurToast } from "@app/components/compta/coquille/ContexteToast";
import { LayoutCompta } from "@app/components/compta/coquille/LayoutCompta";

// La coquille des routes PRODUIT du cabinet : trois couches (configuration,
// toasts, mise en page) posées autour des écrans montés sous `/w/:wId`.
//
// Pourquoi ce composant existe : son absence a été payée. Du 09 au 11/10, la
// Revue puis le Cahier ont été déployés sous `/w/:wId/spaces/:spaceId/...`
// SANS fournisseur de coquille, que seul le labo montait alors.
// `useConfigurerCoquille` lève sans fournisseur, donc les deux écrans
// plantaient à leur adresse produit, pendant que le bundle, l'API et les
// marqueurs étaient tous vérifiés. Le rendu, lui, ne l'était pas.
//
// Un seul élément de route parent dans `cabinetRoutes.tsx`, et chaque écran
// branché en est un enfant.
export function CoquilleProduit() {
  return (
    <FournisseurCoquille>
      <FournisseurToast>
        <LayoutCompta />
      </FournisseurToast>
    </FournisseurCoquille>
  );
}
